import React from "react"
import TextInput from "../../../components/InputBoxes/TextInput"

const PhoneNumberSection = ({
  onChange,
  value = "",
  onClick,
  isCheckBoxChecked=false,
  visible = false,
  toggleSignUpLoginModal
}) => {
  return (
    <div
      className={`sliding-panel flex flex-col items-center ${
        visible ? "" : "slideData"
      }`}
    >
      {visible ? (
        <>
          <p className="text-[#424952D9] font-[400] text-[14px] leading-[22px] text-center mb-[20px]">
            Kick off your Fastfin experience.
          </p>
          <TextInput
            value={value}
            type="text"
            onChange={onChange}
            isPhoneNumber
            inputMode="numeric"
            pattern="[0-9]*"
            placeholder="Enter mobile number"
            className="max-w-[526px] w-[80dvw] border-0"
          />
          <div className="flexRow mt-[15px] items-start">
            <input
              type="checkbox"
              style={{
                border: "1px solid #000000",
                padding: "10px",
                borderRadius: "5px",
                marginTop: "5px",
              }}
              checked={isCheckBoxChecked}
              className=""
                onClick={onClick}
            />
            <p className="font-[500] text-[14px] leading-[24px] text-greyText text-opacity-50 ml-[7px]">
              By proceeding, you agree to our
              <a href="/terms" className="underline text-[#04B085]">
                {" "}
                Terms & Conditions
              </a>{" "}
              &{" "}
              <a href="/privacy" className="underline text-[#04B085]">
                {" "}
                Privacy Policy
              </a>
            </p>
          </div>
        </>
      ) : (
        <></>
      )}
    </div>
  )
}

export default PhoneNumberSection
